export const GET_YEAR_QUESTIONS_REQUEST = "GET_YEAR_QUESTIONS_REQUEST";
export const GET_YEAR_QUESTIONS_SUCCESS = "GET_YEAR_QUESTIONS_SUCCESS";
export const GET_YEAR_QUESTIONS_FAIL = "GET_YEAR_QUESTIONS_FAIL";

// Available years for selected subjects
export const GET_AVAILABLE_YEARS_REQUEST = "GET_AVAILABLE_YEARS_REQUEST";
export const GET_AVAILABLE_YEARS_SUCCESS = "GET_AVAILABLE_YEARS_SUCCESS";
export const GET_AVAILABLE_YEARS_FAIL = "GET_AVAILABLE_YEARS_FAIL";
export const CLEAR_AVAILABLE_YEARS = "CLEAR_AVAILABLE_YEARS";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
